import { useMutation } from '@tanstack/react-query';
import { logoutService } from '../service/session';
import { clearAuthSession } from '@/features/auth/session';
import { clearZustandStore } from '@/legacy/store/zustand';
import { clearAllTableSessionParams } from '@/legacy/features/table/utils';
import { queryClient } from '@/legacy/lib';
import { logger } from '@/shared/logger';

const APP_VERSION_KEY = 'app_version';

// Best-effort, never rejects — matches the legacy `signout` thunk, whose
// try/catch/finally always resolves regardless of the API call's outcome.
//
// Composes the same full reset as app/appReset.ts's resetAppState() — kept
// separate rather than imported, since features/ must not import app/ (keep
// the two in sync if either changes).
export const useLogout = () =>
	useMutation({
		mutationKey: ['auth', 'logout'],
		mutationFn: async () => {
			try {
				await logoutService();
			} catch (error) {
				logger.error('Logout request failed', error);
			} finally {
				clearAuthSession();
				clearZustandStore();

				const appVersion = localStorage.getItem(APP_VERSION_KEY);
				localStorage.clear();
				if (appVersion) localStorage.setItem(APP_VERSION_KEY, appVersion);

				clearAllTableSessionParams();
				queryClient.clear();
			}
		},
	});
